import { btnDelay } from "common/utils";
/**
 * Step 1: アイコン選択方法ステップ
 */
import I18n from "features/shared/i18n";
import {
  EditorState,
  EditorStep,
  IconMethod,
} from "../types";

interface IconMethodStepProps {
  state: EditorState;
  updateState: (updates: Partial<EditorState>) => void;
  goToStep: (step: EditorStep) => void;
  /** 狭い画面向け表示（カードを縦1列に並べる） */
  narrow?: boolean;
}

export const IconMethodStep = ({ updateState, goToStep, narrow = false }: IconMethodStepProps) => {
  const handleSelectPreset = () => {
    btnDelay(() => {
      updateState({ iconMethod: IconMethod.PRESET });
      goToStep(EditorStep.PRESET_ICON);
    });
  };

  const handleSelectUpload = () => {
    btnDelay(() => {
      updateState({ iconMethod: IconMethod.UPLOAD, icon: "" });
      goToStep(EditorStep.UPLOAD_ICON);
    });
  };

  const handleSelectProfileAI = () => {
    btnDelay(() => {
      updateState({ iconMethod: IconMethod.PROFILE_AI });
      goToStep(EditorStep.PROFILE_AI);
    });
  };

  // 狭い画面ではアイコン+テキスト横並びの横長ボタン、通常は従来の正方形カード
  const cardClass = narrow
    ? "flex-row-el items-center justify-center gap-3 w-full py-5 rounded-[8px] cursor-pointer select-none"
    : "flex-col-el items-center justify-center w-[220px] h-[220px] rounded-[4px] cursor-pointer select-none";
  const cardIconClass = narrow
    ? "material-symbols-outlined !text-4xl text-white"
    : "material-symbols-outlined !text-5xl text-white mb-3";
  const cardLabelClass = narrow
    ? "text-body text-[22px] text-white"
    : "text-body text-[22px] text-white text-center whitespace-pre-line";

  return (
    <div className="flex-col-el flex-center w-full min-h-full">
      <div className="flex-col-el flex-center mb-8">
        <p className="text-body text-textcolor-black text-[32px] text-center">
          {I18n.t("MSG_ICON_SELECT_TITLE_BY_PARENT")}
        </p>
      </div>

      <div
        className={
          narrow ? "flex-col-el items-stretch gap-4 w-full" : "flex-row-el flex-center gap-4"
        }
      >
        <div onClick={handleSelectPreset} className={`${cardClass} bg-orange-100`}>
          <span className={cardIconClass}>grid_view</span>
          <p className={cardLabelClass}>{I18n.t("MSG_ICON_SELECT_SYSTEM_BY_PARENT")}</p>
        </div>

        <div onClick={handleSelectUpload} className={`${cardClass} bg-green-100`}>
          <span className={cardIconClass}>upload</span>
          <p className={cardLabelClass}>{I18n.t("MSG_ICON_SELECT_UPLOAD_BY_PARENT")}</p>
        </div>

        <div onClick={handleSelectProfileAI} className={`${cardClass} bg-blue-100`}>
          <span className={narrow ? cardIconClass : `${cardIconClass} mt-8`}>auto_awesome</span>
          <p className={cardLabelClass}>{I18n.t("MSG_ICON_SELECT_PROFILE_AI_BY_PARENT")}</p>
        </div>
      </div>
    </div>
  );
};
